<template>
  <GChart
    :settings="chartSettings"
    type="Gauge"
    :data="chartData"
    :options="chartOptions"
    :resizeDebounce="500"
  />
</template>

<script>
import { GChart } from 'vue-google-charts';

export default {
  name: "Gauge",
  data() {
    return {
      defaultOptions: {
        redFrom: 0, redTo: 15,
        yellowFrom: 15, yellowTo: 30,
        greenFrom: 30, greenTo: 100,
        minorTicks: 5, majorTicks: 15,
        width: 400, height: 400
      },
      defaultSettings: { packages: ['gauge'] }
    }
  },
  props: ['initialData', 'overrideOptions', 'overrideSettings'],
  computed: {
    chartData: function() {
      return this.initialData
    },
    chartOptions: function() {
      if (!this.overrideOptions) {
        return this.defaultOptions;
      }

      const chartOptions = this.defaultOptions;

      const keys = Object.keys(this.overrideOptions);

      for (let i = 0; i < keys.length; i++) {
        chartOptions[keys[i]] = this.overrideOptions[keys[i]];
      }

      return chartOptions;
    },
    chartSettings: function() {
      if (!this.overrideSettings) {
        return this.defaultSettings;
      }

      const chartSettings = this.defaultSettings;

      const keys = Object.keys(this.overrideSettings);

      for (let i = 0; i < keys.length; i++) {
        // if the custom settings contains the 'packages' key, move on. We don't want it to be changed for this component
        if (keys[i] === 'packages')
          continue;

        chartSettings[keys[i]] = this.overrideSettings[keys[i]];
      }

      return chartSettings;
    }
  },
  components: {GChart}
}
</script>

<style scoped>

</style>
